import React from "react";
import { Link } from "react-router-dom";

const LinkC = ({children, to}) => (
  <Link to={to} className="lg:text-lg xl:texl-xl link hidden lg:inline pb-2.5 pt-px  ">
    {children}
  </Link>
);

export default LinkC;
